import Log from "../../../../pages/Config/Logs";

const routerLog = [
    {
        key: "logs",
        path: "/config/logs",
        element: <Log />,
    },
]

export default routerLog
